import React from "react";

export const AppLogo = (active) => {
  return (
    <React.Fragment>
      <img src={require("../../../Assets/Images/Saleoid-final.png")} />
    </React.Fragment>
  );
};
